import TableEmptyRow from 'components/others/TableEmptyRow';
import StockLotsTableRow from './StockLotsTableRow';
import type { StockLotRow } from './types';

interface StockLotsTableBodyProps {
    rows: StockLotRow[];
    showPrices: boolean;
    showRate: boolean;
    isUahMode: boolean;
    plainStock?: boolean;
}

const StockLotsTableBody = ({ rows, showPrices, showRate, isUahMode, plainStock = false }: StockLotsTableBodyProps) => {
    const colSpan = (showPrices ? 1 : 0) + (showRate ? 1 : 0) + 1;

    return (
        <tbody>
            {!rows.length ? (
                <TableEmptyRow colSpan={colSpan} />
            ) : (
                rows.map((row, index) => (
                    <StockLotsTableRow
                        key={`${row.operPrice}-${row.operPriceRate}-${index}`}
                        row={row}
                        showPrices={showPrices}
                        showRate={showRate}
                        isUahMode={isUahMode}
                        plainStock={plainStock}
                    />
                ))
            )}
        </tbody>
    );
};

export default StockLotsTableBody;
